import { render, staticRenderFns } from "./ChecklistComplexPicker.vue?vue&type=template&id=1523e384&lang=pug&"
import script from "./ChecklistComplexPicker.vue?vue&type=script&lang=js&"
export * from "./ChecklistComplexPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports